module.exports = __webpack_public_path__ + "images/hero_mission5_8b0b7c2e9dc7ea192953ffb1b2d7bc84.png";